import fetch from 'isomorphic-fetch'
import { getAPIendpointPrefix } from '../../client/actions/apiHelper'

export default function logToLoggly (msg, severity = 'INFO') {
  fetch(getAPIendpointPrefix() + 'api/v1/loggly.php', {
    method: 'POST',
    body: JSON.stringify({
      message: msg,
      severity
    })
  }).then(res => res.text())
}
